import React from 'react';
import Header from './index.style';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ADVERTISE_FLAGSMITH_KEYS, MY_INFO_RESGISTRATION_URL } from '../../utils/constants';
import { store } from '../../store';
import get from 'lodash/get';
import Advertising from '../../containers/advertising/Advertising';
import { logEvent } from '../../utils/events/logUserEvents';
import { FLOW_TYPE_DASHBOARD } from '../../utils/constants/eventsConstants';
import { LOG_TYPE } from '../../utils/events/eventsConstants';
import { CHEVRON_RIGHT_ICON } from '@Images';

const Welcome = ({ userName, isNewKYCFlow, newKYCFlowContent: { title, description } }) => {
  const cleverTapEventHandler = () => {
    const status = get(store.getState(), 'rootReducer.userStatusReducer.status', '');
    let ctData = {
      pageName: 'Dashboard Page',
      status: status === 'REGISTERED' ? 'Start' : 'Complete'
    };
    logEvent('verify', FLOW_TYPE_DASHBOARD, ctData, LOG_TYPE.CLEVER_TAP);
  };
  const greetingText = `Hello ${userName.toLowerCase()}`;
  return (
    <Header>
      <div>
        <h1 className="header">{greetingText}</h1>
        <p className="sub-header">Welcome to Instarem</p>
      </div>
      {isNewKYCFlow && title && description && (
        <Link
          to={MY_INFO_RESGISTRATION_URL}
          className="new-kyc-flow"
          onClick={cleverTapEventHandler}
        >
          <div>
            <h1>{title}</h1>
            <p>{description}</p>
          </div>
          <img src={CHEVRON_RIGHT_ICON} alt="navigate" />
        </Link>
      )}
      <Advertising advertisements={ADVERTISE_FLAGSMITH_KEYS} noMarginRight={true} />
    </Header>
  );
};
Welcome.propTypes = {
  userName: PropTypes.string,
  device: PropTypes.string,
  userStatus: PropTypes.string,
  isNewKYCFlow: PropTypes.bool,
  newKYCFlowContent: PropTypes.object
};

export default Welcome;
